import React from 'react'
import EducationHeader from './EducationHeader'
import MsingiPoa from './MsingiPoa'
import ElimuBora from './ElimuBora'
import SuperE from './SuperE'
import Boresha from './Boresha'
import ElimuSmart from './ElimuSmart'

function Education() {
  return (
    <div>
        <EducationHeader/>
        <MsingiPoa/>
        <ElimuBora/>
        <SuperE/>
        <Boresha/>
        <ElimuSmart/>
        


    </div>
  )
}

export default Education